'use client';

import { HoverableLogo } from '@/components/SiteHeader/HoverableLogo';
import { LinksList } from '@/components/SiteHeader/LinksList';
import { MobileMenu } from '@/components/SiteHeader/MobileMenu';
import { VerticalsMenu } from '@/components/SiteHeader/VerticalsMenu';
import { SiteSearch } from '@/components/SiteSearch';
import { ThemeToggle } from '@/components/ThemeToggle';
import { Wrapper } from '@/components/Wrapper';
import type { SiteNavMenuType } from '@/lib/firestore/dataFetchers/getSiteNavMenu';
import { useSiteHeader, useTheme } from '@/providers';

export interface SiteHeaderProps {
  headerData?: SiteNavMenuType;
}

export function SiteHeader({ headerData }: SiteHeaderProps) {
  const { siteHeaderMainRef } = useSiteHeader();
  const { showToggle } = useTheme();

  return (
    <div className="flex flex-col border-b border-primary">
      {/* Top half, always visible */}
      <Wrapper>
        <div
          className="flex items-center justify-between py-6 gap-5 md:gap-2"
          ref={siteHeaderMainRef}
        >
          <div className="flex gap-5 grow md:grow-0">
            <div className="shrink-0 grow-0">
              <HoverableLogo />
            </div>
            <SiteSearch />
          </div>
          <div className="flex items-center gap-x-6 gap-y-half flex-wrap justify-end">
            <div className="hidden md:block">
              <LinksList />
            </div>
            <MobileMenu topics={headerData} />
            {showToggle && (
              <div className="hidden md:block">
                <ThemeToggle />
              </div>
            )}
          </div>
        </div>
      </Wrapper>

      {/* Bottom half, visible on desktop */}
      <VerticalsMenu headerData={headerData} />
    </div>
  );
}
